module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step3_7-5f8a535bd8416fe97baef76e3d22ca7a.png";